import { render, staticRenderFns } from "./GadgetDescription.vue?vue&type=template&id=1559134c&scoped=true"
import script from "./GadgetDescription.vue?vue&type=script&lang=js"
export * from "./GadgetDescription.vue?vue&type=script&lang=js"
import style0 from "./GadgetDescription.vue?vue&type=style&index=0&id=1559134c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559134c",
  null
  
)

export default component.exports